/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Culture_CodeInputs */

const en_reference_field_culture_code = /** @type {(inputs: Reference_Field_Culture_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Culture code`)
};

/**
* | output |
* | --- |
* | "Culture code" |
*
* @param {Reference_Field_Culture_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_culture_code = /** @type {((inputs?: Reference_Field_Culture_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Culture_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_culture_code(inputs)
});